<template>
  <q-page padding>
    <PageHeader
      title="Estoque Atual"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Unidade</div>

        <lista-unidades-select
          v-model="filtros.unidadeOrigem"
        ></lista-unidades-select>
      </div>
      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Categoria</div>
        <q-input
          dense
          class="texto-titulo-input"
          outlined
          v-model="filtros.categoria"
        />
      </div>
      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Grupo</div>
        <q-input
          dense
          class="texto-titulo-input"
          outlined
          v-model="filtros.grupo"
        />
      </div>
      <div class="col-md col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Recurso (Conta Contabil):</div>
        <q-input
          dense
          class="texto-titulo-input"
          outlined
          v-model="filtros.recurso"
        />
      </div>
      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Somente com Recurso:</div>

        <q-select
          dense
          outlined
          class="texto-titulo-input"
          v-model="filtros.status"
          :options="listaStatus"
          emit-value
          map-options
        >
        </q-select>
      </div>

      <div class="col-md col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Somente com Recurso:</div>

        <q-select
          dense
          outlined
          class="texto-titulo-input"
          v-model="pagination.rowsPerPage"
          :options="perPageList"
          emit-value
          map-options
        >
        </q-select>
      </div>
    </div>
    <div class="q-mt-xl">
      <div
        class="row items-center justify-between q-ml-md text-brand-5 text-weight-bold titulo-tabela"
      >
        <span>Produtos do catálogo ({{ pagination.rowsNumber }})</span>

        <span class="column items-end">
          <q-btn
            @click="exportar"
            class="q-mb-sm"
            label="Exportar"
            no-caps
            style="
              border-radius: 8px;
              background-color: #21324a;
              color: white;
              max-width: 127.2px;
            "
            icon="file_upload"
          />
          <q-input
            rounded
            outlined
            class="col-md-3 col-xs-12 q-mr-sm"
            dense
            debounce="300"
            v-model="busca"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </span>
      </div>

      <q-table
        table-header-style="background-color: #d9effc"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        color="primary"
        dense
        row-key="id"
        :grid="mobile"
        flat
        v-model:pagination="pagination"
        no-data-label="Sem dados"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-12 col-md-6">
            <div class="row card">
              <div class="col-12">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="col-12">
                    <span
                      ><strong>Origem:</strong>
                      {{ props.row.unidadeNomeOrigem }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Destino:</strong>
                      {{ props.row.unidadeNomeDestino }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Nº Picking:</strong> {{ props.row.numero }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Data de Criação:</strong>
                      {{
                        props.row?.dataCriacao
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}
                      {{ props.row?.dataCriacao.split(" ")[1] }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Criador:</strong>
                      {{
                        props.row.usuarioCriacao
                          ? `${props.row?.usuarioCriacao?.name} -`
                          : ""
                      }}{{
                        props.row.usuarioCriacao
                          ? ` ${props.row?.usuarioCriacao?.sap}`
                          : ""
                      }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Colaborador:</strong>
                      {{
                        props.row.usuarioSolicitante
                          ? `${props.row?.usuarioSolicitante?.name} -`
                          : ""
                      }}{{
                        props.row.usuarioSolicitante
                          ? ` ${props.row?.usuarioSolicitante?.sap}`
                          : ""
                      }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Contagem de Produtos:</strong>
                      {{ props.row?.itens?.length }}
                    </span>
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Status:</strong>
                      {{
                        `${props.row?.status
                          ?.charAt(0)
                          .toUpperCase()}${props.row?.status.substring(1)}`
                      }}
                    </span>
                  </div>
                </q-card-section>
              </div>
              <div class="col-12">
                <div class="text-brand-5 btn-grid-container">
                  <div class="row">
                    <div class="column col">
                      <q-btn
                        class="btn-grid-action"
                        stack
                        no-caps
                        :to="{
                          name:
                            props.row?.status == 'criado'
                              ? 'pkg-detalhe'
                              : 'pkg-detalhe-transferencia',
                          params: {
                            id:
                              props.row?.status == 'criado'
                                ? props.row?.pickingUuid
                                : props.row?.numero,
                          },
                        }"
                        label="Detalhe"
                        style="background: #3c76f1; color: white"
                        icon="article"
                      />
                    </div>
                    <div class="column col">
                      <q-btn
                        class="btn-grid-action"
                        stack
                        no-caps
                        label="Cancelar"
                        :disable="props.row.status != 'criado'"
                        :color="
                          props.row.status != 'criado' ? 'grey' : 'negative'
                        "
                        icon="close"
                        @click="
                          (confirmacao = !confirmacao),
                            (cancelarPickingId = props.row.pickingUuid)
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template #body-cell-recurso="props">
          <q-td :props="props">
            <q-input
              dense
              outlined
              label="Digite o recurso"
              style="min-width: 200px; max-width: 200px"
              v-model="props.row.stock[0].pivot.conta_contabil"
            >
            </q-input>
          </q-td>
        </template>

        <template #body-cell-salvar="props">
          <q-td :props="props">
            <q-btn
              icon="done"
              outline
              color="positive"
              round
              @click="salvarRecurso(props.row)"
              flat
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md" v-if="rows?.length > 0">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
          :max-pages="6"
        />
      </div>
    </div>
    <dialog-confirm
      mensagem="Tem certeza que deseja cancelar esse Picking?"
      :exibir="confirmacao"
      :propsClass="'q-pa-md'"
      @resultado="resultado"
    >
    </dialog-confirm>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { watchDebounced } from "@vueuse/core";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

import { useQuasar } from "quasar";
import DialogConfirm from "../components/DialogConfirm.vue";
import PageHeader from "../../../../components/PageHeader.vue";
const columns = [
  {
    name: "id",
    label: "Id",
    field: (row) => row.id,
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "codigo",
    label: "Código",
    field: (row) => row.code,
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "produto",
    label: "Produto",
    field: (row) => row?.pivot?.contract_product_description || row?.name,
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "grupo",
    label: "Grupo de Produto",
    field: (row) => row.pivot?.product_group?.name,
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },

  {
    name: "criador",
    label: "Categoria",
    field: (row) => row.pivot?.product_category?.code,
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },

  {
    name: "medida",
    label: "Unid. Medida",
    field: (row) => row.stock[0]?.pivot?.measurement_unit,
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "recurso",
    label: "Recurso",
    field: "recurso",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "salvar",
    label: "Salvar",
    field: "salver",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
];

export default {
  components: {
    ListaUnidadesSelect,
    DialogConfirm,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const rows = ref([]);
    const filtros = ref({
      unidadeOrigem: "",
      recurso: "",
      status: null,
      categoria: "",
      grupo: "",
    });

    const confirmacao = ref(false);
    const cancelarPickingId = ref(null);
    const busca = ref("");
    const disable = ref(true);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 10,
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile = ref(true);
    }

    const getDados = async (page = 1, rowsPerPage = 10) => {
      disable.value = true;
      store.dispatch("pdt/hiddenHeader", true);
      try {
        let response = await store.dispatch("fiscalStore/getListagemEstoque", {
          page: page,
          per_page: rowsPerPage,
          search: busca.value == "" ? undefined : busca.value,
          vendor_id: filtros.value.unidadeOrigem
            ? filtros.value.unidadeOrigem.id
            : undefined,
          categoria:
            filtros.value.categoria == "" ? undefined : filtros.value.categoria,
          conta_contabil:
            filtros.value.recurso == "" ? undefined : filtros.value.recurso,
          com_conta_contabil: filtros.value.status,
          grupo: filtros.value.grupo == "" ? undefined : filtros.value.grupo,
          contract_id: store.state.org.contract,
        });

        rows.value = response.data.model.products.data;

        pagination.value.rowsPerPage = response.data.model.products.per_page;
        pagination.value.rowsNumber = response.data.model.products.total;
        pagination.value.page = response.data.model.products.current_page;

        disable.value = false;
      } catch (error) {
        disable.value = false;
        quasar.notify({
          message: "Erro a o listar picking",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);
    const salvarRecurso = async (row) => {
      try {
        await store.dispatch("fiscalStore/salvarRecurso", {
          conta_contabil: row.stock[0].pivot.conta_contabil,
          product_id: row.id,
          vendor_id: filtros.value.unidadeOrigem
            ? filtros.value.unidadeOrigem.id
            : undefined,
        });

        quasar.notify({
          message: "Recurso Salvo com Sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o salvar recurso",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const exportar = async () => {
      try {
        await store.dispatch("fiscalStore/exportListagemEstoque", {
          contract_id: store.state.org.contract,
        });

        quasar.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resultado = async (resposta) => {
      confirmacao.value = !confirmacao.value;
      if (resposta) {
        try {
          await store.dispatch("pkg/cancelarPicking", {
            id: cancelarPickingId.value,
          });

          quasar.notify({
            message: "Picking cancelado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          disable.value = false;
          getDados();
        } catch (error) {
          quasar.notify({
            message: "Erro a o cancelar picking",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidadeOrigem = store.state.org.unidadeData;
      }
    );
    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watchDebounced(
      [
        () => busca.value,
        () => filtros.value.recurso,
        () => filtros.value.categoria,
        () => filtros.value.status,
        () => filtros.value.grupo,
        () => pagination.value.page,
        () => pagination.value.rowsPerPage,
      ],
      () => {
        disable.value = true;
        handleRequest();
      },
      { debounce: 400 }
    );

    return {
      filtros,
      pagination,
      disable,
      columns,
      exportar,
      handleRequest,

      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      perPageList: [15, 30, 50, 100, 150, 200],

      confirmacao,
      rows,
      resultado,
      cancelarPickingId,
      mobile,
      salvarRecurso,
      busca,
    };
  },
};
</script>

<style scoped>
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.texto-titulo {
  font-size: 20px;
}
.card {
  border: 1px solid #707070;
}
.text-grid-table {
  font-size: 19px;
}
@media (max-width: 1024px) {
  .texto-titulo-input {
    font-size: 14px;
  }
  .titulo-tabela {
    font-size: 20px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .btn-grid {
    font-size: 19px;
  }
  .btn-grid-action {
    font-size: 16px;
    border-radius: 0px;
  }
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 17px;
  }
  .texto-titulo-input {
    font-size: 15px;
  }
  .titulo-tabela {
    font-size: 15px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-colunas {
    font-size: 10px;
  }
  .btn-grid {
    font-size: 15px;
  }
  .btn-grid-action {
    font-size: 12px;
    border-radius: 0px;
  }
  .text-grid-table {
    font-size: 15px;
  }
}
</style>
